import React from "react";
import { Grid, Icon } from "semantic-ui-react";
import InputField from "../../../commonComponents/formComponents/inputField";
import DropDown from "../../../commonComponents/formComponents/dropDown";
import { useSelector } from "react-redux";
import DeleteIcon from "../../../commonComponents/deleteIcon";

const FiscalReferenceDetails=({item:{id,eoriNo,frRoleCode,invoiceActorRoleId,roleId},deleteData,updateData, saveData, invoiceId})=>{
 
  const additionalFiscalReferencesType= useSelector((state) => state.DropDownValues.additionalFiscalReferencesType);

  const isFormDisabled = false;
  
  return (
    <Grid.Row>
      <Grid.Column
        width="5"
        className="divFormFeild border-bottom"
      >
        <DropDown
          id={`authType-${invoiceId}-${id}`}
          label="TYPE"
          boxNumber="3/40"
          disabled={isFormDisabled}
          className="field-bg dropdown100"
          labelClass="text-none"
          isLabel={true}
          data={additionalFiscalReferencesType}
           value={frRoleCode}
           onChange={(value) =>{
            saveData({id,frRoleCode:value,roleId,invoiceActorRoleId})
            updateData(id,{"frRoleCode":value})}
          }
          
        />
      </Grid.Column>
      <Grid.Column
        width="10"
        className="divFormFeild  border-bottom "
      >
        <InputField
          isLabel={false}
          id={`authIdentification-${invoiceId}-${id}`}
          type="text"
          label="IDENTIFICATION"
          boxNumber="3/40"
          value={eoriNo}
          className={"field-bg"}
          clearInput={false}
          onChange={(value) => updateData(id,{"eoriNo":value})}
          onBlur={(value) => saveData({id, eoriNo:value||' ',roleId,invoiceActorRoleId})}
          disabled={isFormDisabled}
        />
      </Grid.Column>
     
      <Grid.Column width="1" className="icon-delete-add-info">
        <DeleteIcon id={`delete-${invoiceId}-${id}`} onClick={() => deleteData(id)} />
      </Grid.Column>
    </Grid.Row>
  );
}
export default React.memo(FiscalReferenceDetails)
